import React from 'react'
import { Link, Image } from '@ta-interaktiv/contentbricks'
import { browserCheck } from '@ta-interaktiv/browsercheck'
const isMobile = browserCheck.isMobile

export const victims = [
  {
    n: 'En lire davantage',
    imageOverview: (
      <>
        <img
          src={require('../../images/alma/ilda_alma-verpixelt-bw.jpg')}
          className='ui fluid image portraitImageFront'
          style={{ margin: '0 auto' }}
        />
      </>
    ),
    imageIntro: (
      <>
        <Image
          file={require('../../images/alma/ilda-alma-verpixelt.jpg')}
          className='portraitImageBack'
          source='Le jour du drame, Alma B. (à g.) recevait la visite de sa sœur Ilda, qui était domiciliée en France (à dr.). (Photo: Facebook)'
        />
      </>
    ),

    table: (
      <>
        <table className='ui small compact unstackable inverted table fact'>
          <tbody>
            <tr>
              <td className='bold'>Le mari était violent</td>
            </tr>
            <tr className='top aligned'>
              <td>
                Alma B. (†38), Ilda F. (†31)
                <br />
                <span className='darkgrey'>
                  Poignardées le 8 janvier 2018 à Hausen (AG)
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </>
    ),

    titleLead: (
      <>
        <h4>Il dit avoir tué par légitime défense</h4>
        <div className='lead'>
          Un quinquagénaire aurait poignardé, chez lui, sa femme et sa
          belle-sœur. L’homme avait déjà été arrêté pour violence domestique.
        </div>
      </>
    ),

    case: (
      <>
        <p>
          Ilir B.* a reconnu les faits, mais il les a justifiés. À la police, il
          a expliqué avoir agi par légitime défense. Sa femme, Alma B., 38 ans,
          et sa belle-sœur, Ilda F., l’auraient attaqué par surprise chez lui, à
          Hausen (AG) et il aurait dû se défendre avec un couteau. Cette version
          des faits n’a pas convaincu le Ministère public, qui accuse l’homme
          d’avoir intentionnellement poignardé les deux sœurs en pleine
          poitrine. Il reste présumé innocent jusqu’à l’issue du procès qui doit
          avoir lieu à la fin de l’année. Le procureur a déjà requis 20 ans de
          prison.
        </p>
        <p>
          C’est un appel téléphonique qui a prévenu la police, le matin du 8
          janvier 2018. Au domicile familial, les agents ont trouvé les deux
          cadavres, un couteau et l’auteur présumé, qui a été aussitôt arrêté.
          Une expertise psychiatrique a révélé par la suite qu’Ilir B., 57 ans,
          souffrait d’une dépression. La justice a d’ailleurs assorti la peine
          d’une obligation de suivi thérapeutique.
        </p>

        <Image
          file={require('../../images/alma/tatort-hausen.jpg')}
          className='imageCase'
          source="Des spécialistes de la police cantonale d'Argovie sur le lieu de l'homicide (Photo : Keystone)"
        />

        <p>
          Selon la presse albanophone, la jeune femme venait d’avoir 18 ans
          lorsqu’elle a rencontré Ilir B. Après s’être mariés au Kosovo, leur
          pays d’origine, ils se sont installés en Suisse et ont eu trois
          enfants (ceux-ci étaient à l’école au moment des faits). Toujours
          selon la presse, Alma B. vivait un enfer avec son mari et cherchait du
          soutien. L’homme, de presque vingt ans son aîné, était jaloux, la
          maltraitait et lui interdisait de sortir de chez elle.
        </p>
        <p>
          La jeune femme avait tenté de réagir et avait demandé de l’aide,
          notamment à sa sœur Ilda, qui se trouvait par hasard à Hausen le jour
          du drame. Elle avait aussi déposé une plainte contre son époux auprès
          des autorités argoviennes. Une enquête avait donc été ouverte, et Ilir
          B. avait été interpellé. Alma B. avait finalement retiré sa plainte,
          ce qui avait provoqué l’abandon total des poursuites.
        </p>

        <p>
          Ce cas de figure n’est plus possible aujourd’hui, le Conseil fédéral
          ayant durci la loi.{' '}
          <Link
            allowWordWrap
            href='https://www.admin.ch/gov/fr/accueil/documentation/communiques.msg-id-75689.html'
          >
            Depuis le 1er juillet 2019
          </Link>
          , la plainte ne peut plus être suspendue si la justice estime qu’il y
          a des preuves de maltraitance répétée au sein du couple. L’expérience
          montrant que les femmes se rétractent parce qu’elles ont peur de leur
          agresseur ou qu’elles sont sous son emprise, cette modification
          législative a pour but de protéger les femmes contre elles-mêmes.
        </p>

        <p className='source'>* Prénom d’emprunt</p>
      </>
    )
  },
  {
    n: 'En lire davantage',
    imageOverview: (
      <>
        <img
          src={require('../../images/annagret/avatar-annagret.svg')}
          className='ui fluid image portraitImageFront'
          style={{ margin: '0 auto' }}
        />
      </>
    ),
    imageIntro: (
      <>
        {/* <Image
          file={require('../../images/victims/avatar-annagret.svg')}
          className='portraitImageBack'
          source='Annagret F. (†83)'
        /> */}
      </>
    ),

    table: (
      <>
        <table className='ui small compact unstackable inverted table fact'>
          <tbody>
            <tr>
              <td className='bold'>Vivre et mourir avec son épouse</td>
            </tr>
            <tr className='top aligned'>
              <td>
                Annagret F. (†83)
                <br />
                <span className='darkgrey'>
                  Tuée par balle le 10 janvier 2018 à Affoltern am Albis (ZH)
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </>
    ),

    titleLead: (
      <>
        <h4>Il la tue puis se suicide</h4>
        <div className='lead'>
          Un retraité a tué sa femme malade sur son lit d’hôpital puis a
          retourné l’arme à feu contre lui. La famille explique que ce couple
          fusionnel ne pouvait pas envisager la séparation.
        </div>
      </>
    ),

    case: (
      <>
        <p>
          Annagret F. (alors âgée de 83 ans) venait d’être{' '}
          <Link
            allowWordWrap
            href='https://www.google.ch/maps/place/Spital+Affoltern/@47.284801,8.4543933,571m/data=!3m2!1e3!4b1!4m5!3m4!1s0x4790062fe8121d6d:0x3a2c0bf295126950!8m2!3d47.284801!4d8.456582'
          >
            hospitalisée à Affoltern am Albis (ZH)
          </Link>
          . Elle se trouvait dans sa chambre avec son mari Max* au moment du
          drame, le 10 janvier 2018. L’homme l’a tuée avec une arme de poing
          puis s’est suicidé. C’est le personnel, alerté par les coups de feu,
          qui a découvert les corps. Elle était allongée sur son lit. Lui gisait
          par terre à côté d’elle.
        </p>

        <Image
          file={require('../../images/annagret/spital-affoltern.jpg')}
          className='imageCase'
          source='Annagret F. était hospitalisée à Affoltern, dans le canton de Zurich. (Photo: Samuel Schalch)'
        />

        <p>
          L’homme était un boucher de métier, reconverti dans la restauration.
          Il avait tenu avec son épouse une adresse bien connue dans la petite
          commune de la banlieue de Zurich. Au lendemain du drame, la presse
          locale a salué la mémoire de ce couple inséparable qui animait les
          tables des habitués et traitaient leurs clients comme des rois.
        </p>

        <Image
          file={require('../../images/annagret/wirt-max.png')}
          className='imageCase'
          source='Max F. vantait les mérites de son restaurant sur internet. (Photo: Screenshot/VGT)'
        />

        <p>
          Arrivés à la retraite, Annagret et Max F. ont continué à vivre
          ensemble, à nourrir des projets communs. Jusqu’à la grave maladie
          d’Annagret, qui a tout bouleversé. Fin 2017, peu avant Noël, elle a
          été hospitalisée. Max F. ne voulant pas la quitter, la direction de
          l'établissement lui a accordé exceptionnellement l’autorisation de
          dormir avec son épouse malade.
        </p>

        <p>
          Une enquête a été ouverte, comme le demande la procédure. L’affaire a
          été rapidement classée. L’auteur est décédé et il n’y a aucun signe
          d’une intervention extérieure. «C'était un homicide, suivi d’un
          suicide», nous a brièvement résumé Erich Wenzinger, du Ministère
          public du canton de Zurich, en juillet 2020. «Ils ont toujours marché
          ensemble dans la vie et ont voulu rester unis même dans la mort», ont
          écrit les proches dans un avis mortuaire paru dans la presse.
        </p>

        <p className='source'>* Prénom d’emprunt</p>
      </>
    )
  },
  {
    n: 'En lire davantage',
    imageOverview: (
      <>
        <img
          src={require('../../images/hanni/avatar-hanni.svg')}
          className='ui fluid image portraitImageFront'
          style={{ margin: '0 auto' }}
        />
      </>
    ),
    imageIntro: (
      <>
        {/* <Image
          file={require('../../images/hanni/avatar-hanni.svg')}
          className='portraitImageBack'
          source='Hanni S. (†79)'
        /> */}
      </>
    ),

    table: (
      <>
        <table className='ui small compact unstackable inverted table fact'>
          <tbody>
            <tr>
              <td className='bold'>Ensemble jusqu’à la mort</td>
            </tr>
            <tr className='top aligned'>
              <td>
                Hanni S. (†79)
                <br />
                <span className='darkgrey'>
                  Tuée par balle le 12 janvier 2018 à Oftringen (AG)
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </>
    ),

    titleLead: (
      <>
        <h4>Il tue sa femme malade puis se suicide</h4>
        <div className='lead'>
          Hanni S. était malade et son état s’aggravait. Son mari, qui
          s’occupait d’elle, l’a abattue avant de se suicider.{' '}
        </div>
      </>
    ),

    case: (
      <>
        <p>
          C’est une infirmière à domicile qui a alerté la police argovienne. Le
          12 janvier 2018, elle effectue sa visite de routine chez Hanni S., à
          Oftringen (AG), pour lui administrer ses soins. Sur place, elle
          découvre le cadavre de la retraitée, à côté de celui de son mari,
          Hans*. L’autopsie attestera que les époux sont morts des suites d’une
          blessure par balle. Le couple était âgé respectivement de 79 et 82
          ans.
        </p>

        <Image
          file={require('../../images/hanni/tatort-oftringen.jpg')}
          className='imageCase'
          source='Le couple de retraités logeait dans ce quartier d’Oftringen. (Photo: Andrea Zahler)'
        />

        <p>
          Hanni S. était malade. Sa situation se détériorait. Elle avait
          toujours plus de peine à se déplacer et était de moins en moins
          indépendante, selon la presse alémanique. La retraitée bénéficiait de
          l’aide de son mari. Il avait d’ailleurs toujours été là pour elle, à
          son service, dans les bons et les mauvais moments, selon plusieurs
          témoignages.
        </p>

        <p>
          La veille du drame, un voisin a{' '}
          <Link href='https://www.blick.ch/news/schweiz/mittelland/zweiter-fall-innert-einer-woche-rentner-toetet-seine-frau-und-dann-sich-selbst-heinz-sagte-noch-er-gebe-hanni-nicht-weg-id7844123.html'>
            raconté au «Blick»
          </Link>{' '}
          les avoir vus dans le quartier. Hans S. aidait son épouse à monter
          dans la voiture et ils faisaient des courses. Le couple semblait
          abattu, mais rien ne laissait présager ce qui arriverait dans les
          heures qui suivraient. Un proche a ajouté qu’il venait d'apprendre que
          Hanni S. souffrait d’une tumeur au cerveau incurable.
        </p>

        <p>
          Une enquête a été ouverte. Contactée, la porte-parole du Ministère
          public argovien, Fiona Strebel, répond que l’instruction a été bouclée
          en quelques mois, en octobre 2018. Les policiers ont trouvé une lettre
          d’adieu à côté des cadavres. «Le courrier était non daté. Il a été
          trouvé dans l'appartement du couple décédé. Le document indiquait
          qu'ils avaient décidé de s’ôter la vie en raison de la maladie
          incurable de l'épouse et de sa mort imminente, prévisible. Rien
          n'indique que des tiers aient pu être impliqués dans la mort du
          couple.»
        </p>
        <p className='source'>* Prénom d’emprunt</p>
      </>
    )
  },
  {
    n: 'En lire davantage',
    imageOverview: (
      <>
        <img
          src={require('../../images/christine/avatar-christine.svg')}
          className='ui fluid image portraitImageFront'
          style={{ margin: '0 auto' }}
        />
      </>
    ),
    imageIntro: (
      <>
        {/* <Image
          file={require('../../images/christine/avatar-christine.svg')}
          className='portraitImageBack'
          source='Christine S. (†73)'
        /> */}
      </>
    ),

    table: (
      <>
        <table className='ui small compact unstackable inverted table fact'>
          <tbody>
            <tr>
              <td className='bold'>Il dit l’avoir tuée par accident</td>
            </tr>
            <tr className='top aligned'>
              <td>
                Christine S. (†73)
                <br />
                <span className='darkgrey'>
                  Tuée par balle le 19 janvier 2018 à Stansstad (NW)
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </>
    ),

    titleLead: (
      <>
        <h4>Le suspect attend en liberté son procès</h4>
        <div className='lead'>
          Un homme a avoué avoir tué sa femme, mais dit que c’était
          involontaire. L’enquête est en cours. Le suspect est libre jusqu’au
          procès.{' '}
        </div>
      </>
    ),

    case: (
      <>
        <p>
          Le vendredi 19 janvier 2018, à 19 h 32, Kurt S.* appelle la centrale
          d’engagement depuis chez lui, à Stansstad. Il déclare avoir tiré sur
          sa femme, Christine S., et qu’elle est morte. Une patrouille se rend
          au domicile et constate la présence d’un cadavre, de l’arme à feu et
          de l’auteur présumé, aussitôt arrêté. L’affaire aurait pu s’arrêter
          là...
        </p>
        <Image
          file={require('../../images/christine/tatort-stansstad.jpg')}
          className='imageCase'
          source='Les faits ont eu lieu à Stansstad, canton de Nidwald. (Photo: Andrea Zahler)'
        />
        <p>
          Kurt S. soutient la thèse de l’accident. Depuis sa prison, il affirme
          qu’il n’a jamais voulu tuer son épouse. Il lui a tiré dessus
          involontairement, par erreur. L’homme a développé ses arguments dans
          sa demande de libération conditionnelle, qu’il a formulée deux mois
          après son arrestation. La cour l’a entendu, estimant qu’il n’y avait,
          notamment, aucun risque de fuite. Depuis, le suspect vit en liberté.
          Il reste présumé innocent jusqu’à l’issue du procès.
        </p>
        <Image
          file={require('../../images/christine/ausriss-medienmitteilung-kapo.png')}
          className='imageCase'
          source='Extrait du communiqué de presse des autorités de Nidwald. (Photo: Screenshot / Kanton NW)'
        />
        <p>
          Le Ministère public était contre cette remise en liberté provisoire.
          Dans sa conclusion rendue le 30 juillet 2020, le procureur estime que
          Kurt S. est coupable d’un crime intentionnel. «Le Ministère public
          accuse l'homme, qui avait 77 ans au moment du crime, d'avoir
          délibérément tiré sur sa femme de 73 ans avec un pistolet dans leur
          appartement commun après une dispute.» L'accusation demande une peine
          de prison de 12 ans.
        </p>
        <Image
          file={require('../../images/christine/Kurt_S_Credit_Facebook.jpg')}
          className='imageFloatLeft'
          source='Kurt S. était un chanteur connu dans la région. (Photo: Facebook)'
        />
        <p>
          Cette version des autorités est mal acceptée à Stansstad, a relaté la
          presse locale. Le suspect, un professeur à la retraite reconnu, est
          aussi un ancien musicien qui a connu les honneurs du hit-parade.
          L’homme bénéficie toujours d’un groupe de fans, qui croient Kurt S.*
          incapable de faire du mal. D’autres avis dans la région prétendent que
          Christine S. était malade et que son mari aurait voulu soulager ses
          souffrances. Le procès est attendu dans les prochains mois.
        </p>

        <p className='maj'>
          <span className='maj-title'>
            Condamné à sept ans, il fait recours
          </span>
          Le 11 décembre 2020, le tribunal cantonal de Nidwald a condamné Kurt
          S. pour le meurtre avec préméditation de sa femme à sept ans de prison
          ferme - le Ministère public avait requis douze ans - et à 9600 francs
          d’amende pour conduite en état d’ivresse. Lors du procès, rapportait
          la "Luzerner Zeitung", l’accusé avait affirmé que sa femme le
          malmenait et l’insultait régulièrement, et qu'il avait seulement voulu
          tirer un coup de semonce avec son pistolet militaire. Durant
          l’enquête, toutefois, des policiers ont expliqué qu'il semblait
          soulagé que celle-ci soit morte. “C’est enfin fait”, aurait-il
          déclaré. Le condamné a fait recours, explique l'Ordre judiciaire.
          L'audience d'appel devrait avoir lieu d'ici à l'été 2021.
        </p>

        <p className='source'>* Prénom d’emprunt</p>
      </>
    )
  },
  {
    n: 'En lire davantage',
    imageOverview: (
      <>
        <img
          src={require('../../images/daniela/daniela-verpixelt-bw.jpg')}
          className='ui fluid image portraitImageFront'
          style={{ margin: '0 auto' }}
        />
      </>
    ),
    imageIntro: (
      <>
        <Image
          file={require('../../images/daniela/daniela-verpixelt.jpg')}
          className='portraitImageBack'
          source='Daniela S. (Photo: Screenshot/Jungfrauzeitung)'
        />
      </>
    ),

    table: (
      <>
        <table className='ui small compact unstackable inverted table fact'>
          <tbody>
            <tr>
              <td className='bold'>Il s’enfuit à l’étranger</td>
            </tr>
            <tr className='top aligned'>
              <td>
                Daniela S. (†41)
                <br />
                <span className='darkgrey'>
                  Raisons de la mort non éclaircies, février 2018 à Frutigen
                  (BE)
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </>
    ),

    titleLead: (
      <>
        <h4>Le suspect nie toute implication</h4>
        <div className='lead'>
          Le quinquagénaire est accusé d’avoir tué Daniela S. chez elle et
          d’avoir voulu faire disparaître son corps dans l’incendie de la
          maison. L’homme, qui a été arrêté en France, conteste.{' '}
        </div>
      </>
    ),

    case: (
      <>
        <p>
          Tout commence, le 15 février 2018, par l’incendie d’une ferme à
          Frutigen, dans le canton de Berne. Les pompiers interviennent et
          parviennent à maîtriser le feu, qui a brûlé presque entièrement la
          maison, en fin de journée. Mais la résidente des lieux, Daniela S., 41
          ans, qui travaille à la Commune, est introuvable. Le lendemain, les
          secours retrouvent son cadavre dans les décombres.
        </p>
        <p>
          La police recherche alors Martin G.* (né en 1963), son compagnon. Elle
          le retrouve trois jours plus tard à Saint-Bonnet-de-Bellac, dans le
          sud-ouest de la France. L’homme explique être en déplacement pour les
          vacances, direction l’Espagne, et ne pas être au courant de la mort de
          Daniela. L’explication ne convainc pas le Ministère public du canton
          de Berne, qui le soupçonne de meurtre intentionnel. Le fuyard est
          extradé vers la Suisse.
        </p>
        <Image
          file={require('../../images/daniela/tatort-frutigen-1.jpg')}
          className='imageCase'
          source='Le corps de Daniela S. a été retrouvé dans les ruines de sa maison. (Photo: BOM / Bruno Petroni)'
        />
        <p>
          L’enquête est difficile. L’incendie a effacé beaucoup de traces, mais
          pas toutes. Le corps de Daniela S. était fortement endommagé. Mais il
          a quand même parlé. L’autopsie a révélé qu’elle pourrait avoir reçu un
          coup mortel sur le crâne. Mais rien est certain. Un doute subsiste,
          notamment sur l’arme du crime qui pourrait être un objet contondant ou
          une arme à feu.
        </p>
        <p>
          D’autres éléments incriminent Martin G.* La justice ne comprend pas,
          par exemple, pourquoi il a évité toutes les zones balayées par des
          caméras de surveillance lors de sa fuite en France. De plus, les
          enquêteurs ont trouvé du mazout dans plusieurs pièces de la maison qui
          a pu jouer un rôle de produit accélérant. C’est sur la base de ces
          indices, et d’autres encore, que cet entrepreneur est accusé
          d’homicide volontaire, d'incendie criminel et d’atteinte à la paix des
          morts.
        </p>
        <p>
          Martin G.* donne une autre version des faits. Daniela aurait eu une
          crampe après avoir consommé des drogues. Une cigarette allumée ou un
          joint serait ensuite tombé sur le matelas de sa chambre et aurait
          provoqué l’incendie. L’homme formule même l’hypothèse du suicide,
          selon les médias. Il jure être innocent et a demandé plusieurs fois sa
          libération avant jugement, ce qui lui a été refusé.
        </p>

        <Image
          file={require('../../images/daniela/tatort-frutigen-2.jpg')}
          className='imageCase'
          source='La ferme a complètement brûlé. (Photo: BOM / Bruno Petroni)'
        />

        <p>
          Le procès aura lieu en octobre 2020. La Cour tentera de déterminer
          pourquoi ce patron réputé et sans histoire, propriétaire d’une
          entreprise dans l’Oberland, s’en serait pris à Daniel S. Le couple
          était apprécié dans le village. Leur relation semblait toutefois
          chaotique, selon des témoignages parus dans les médias. Un témoin
          indique qu’ils étaient fusionnels. Peut-être trop. «Ils n’auraient
          jamais pu vivre l’un sans l’autre.»
        </p>

        <p className='maj'>
          <span className='maj-title'>Mise à jour du 22 décembre 2020</span>Le
          Tribunal régional de Thoune (BE) a condamné Martin G. à une peine de
          16 ans de prison ferme en octobre 2020, après la publication de cet
          article. L’homme qui a toujours clamé son innocence a été reconnu
          coupable d'homicide volontaire, d'incendie criminel et de trouble à
          l'ordre public. Son avocat avait annoncé vouloir faire appel. Le
          détenu a été retrouvé mort dans sa cellule, le 20 novembre 2020. Selon
          les autorités il est décédé des suites d’un «problème médical». Une
          autopsie doit en préciser la cause.
        </p>

        <p className='source'>* Prénom d’emprunt</p>
      </>
    )
  },
  {
    n: 'En lire davantage',
    imageOverview: (
      <>
        <img
          src={require('../../images/cecilia/avatar-cecilia.svg')}
          className='ui fluid image portraitImageFront'
          style={{ margin: '0 auto' }}
        />
      </>
    ),
    imageIntro: (
      <>
        {/* <Image
          file={require('../../cecilia/avatar-cecilia.svg')}
          className='portraitImageBack'
          source='Cecilia P. (†55)'
        /> */}
      </>
    ),

    table: (
      <>
        <table className='ui small compact unstackable inverted table fact'>
          <tbody>
            <tr>
              <td className='bold'>Trois cadavres, deux armes du crime</td>
            </tr>
            <tr className='top aligned'>
              <td>
                Cecilia P. (†55)
                <br />
                <span className='darkgrey'>
                  Tuée par balle le 15 février 2018 à Spreitenbach (AG)
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </>
    ),

    titleLead: (
      <>
        <h4>Il tue avec une arme à feu et un couteau</h4>
        <div className='lead'>
          Un septuagénaire s’est enfermé dans l'appartement, puis a abattu sa
          femme, le petit-fils de celle-ci et s’est suicidé. Les raisons du
          drame restent peu claires.
        </div>
      </>
    ),

    case: (
      <>
        <p>
          Dans la nuit du 15 au 16 février 2018, la police cantonale s’est
          rendue devant la porte d’un appartement de ce tour de 13 étages à
          Spreitenbach (AG). La porte était fermée de l’intérieur. Les agents
          ont dû appeler un service de dépannage pour y entrer. A l’intérieur,
          trois cadavres: un couple de locataires, Walter P.* (77 ans) et sa
          femme Cecilia P. (55 ans), et un petit garçon (4 ans). Un couteau et
          une arme à feu ont été saisis.
        </p>

        <Image
          file={require('../../images/cecilia/tatort-spreitenbach.jpg')}
          className='imageCase'
          source='Les faits se sont produits dans cette tour de 13 étages à Spreitenbach. (Photo: Stefan Ehrbar)'
        />

        <p>
          L’enfant était le petit-fils de la défunte, qu’elle avait l’habitude
          de prendre chez elle en pension. Cette fois-ci, veille de
          l’anniversaire du garçonnet, elle le gardait pour que sa fille - la
          maman - ait le temps de préparer, chez elle, une grande fête surprise.
          Toute la famille s’en réjouissait.
        </p>

        <p>
          C’est la jeune femme qui, n’arrivant pas à joindre sa mère depuis
          plusieurs heures, a alerté les forces de l’ordre. Au préalable, elle
          avait demandé aux voisins du couple de locataires de sonner à leur
          porte. Sans succès. Elle s’était alors rendue dans l’immeuble et avait
          constaté que le silence régnait dans le logement.
        </p>

        <Image
          file={require('../../images/cecilia/ausriss-medienmitteilung-kapo.png')}
          className='imageCase'
          source='Extrait d’un communiqué de presse des autorités argoviennes. (Photo: Screenshot / Kapo AG)'
        />

        <p>
          Le déroulement reste encore peu clair, selon la police. Walter P. a
          tué sa femme, l’enfant, puis s’est suicidé. Cecilia P. a été
          mortellement blessée par un couteau. Son petit-fils a été touché par
          une arme blanche et une arme à feu. L’homme est mort des suites d’une
          surconsommation de médicaments qui a provoqué un infarctus, selon
          l’autopsie médico-légale.
        </p>

        <p>
          Le couple n’avait jamais attiré l’attention dans le quartier avant
          cela. Il était Suisse. Elle était d’origine péruvienne. Selon le
          «Blick», l’époux avait continué à rouler comme chauffeur de taxi
          indépendant, malgré l’âge de la retraite. Une crise cardiaque,
          survenue trois ans auparavant, l’avait contraint toutefois à arrêter.
          De deux décennies sa cadette, Cecilia P. travaillait comme nourrice
          dans le quartier.
        </p>

        <p>
          L’enquête est aujourd’hui close et la justice a déclaré Walter P.*
          coupable. La mort d’un criminel accélère le rythme de la procédure.
          Dans tous les cas, cependant, des investigations préliminaires sont
          menées pour établir les faits. Les familles des victimes y ont droit,
          selon Fiona Strebel, porte-parole du du Ministère public argovien.
        </p>

        <p className='source'>* Prénom d’emprunt</p>
      </>
    )
  },
  {
    n: 'En lire davantage',
    imageOverview: (
      <>
        <img
          src={require('../../images/irene/irene-verpixelt-bw.jpg')}
          className='ui fluid image portraitImageFront'
          style={{ margin: '0 auto' }}
        />
      </>
    ),
    imageIntro: (
      <>
        <Image
          file={require('../../images/irene/irene-verpixelt.jpg')}
          className='portraitImageBack'
          source='Irene F. avait deux enfants. (Photo: Facebook)'
        />
      </>
    ),

    table: (
      <>
        <table className='ui small compact unstackable inverted table fact'>
          <tbody>
            <tr>
              <td className='bold'>Il l’abat de jour en pleine rue</td>
            </tr>
            <tr className='top aligned'>
              <td>
                Irene R. (†35)
                <br />
                <span className='darkgrey'>
                  Tuée par balle le 23 février 2018 à Zurich
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </>
    ),

    titleLead: (
      <>
        <h4>Il ne supportait pas la séparation</h4>
        <div className='lead'>
          Un trentenaire a abattu sa femme, qui venait de le quitter, en plein
          jour dans le centre-ville de Zurich. Peu avant, il était rentré chez
          lui, en Italie, pour se procurer l’arme du crime.
        </div>
      </>
    ),

    case: (
      <>
        <p>
          Alberto V.* était déterminé. Le 23 février 2018, il a tiré sur sa
          femme, Irene R., en plein jour, dans le quartier branché{' '}
          <Link
            allowWordWrap
            href='https://www.google.com/maps/place/Europaallee/@47.3777799,8.5323023,570m/data=!3m1!1e3!4m5!3m4!1s0x47900a0f941f553f:0xc595ad735b6e015f!8m2!3d47.3776637!4d8.5345124'
          >
            d’Europaallee, à Zurich
          </Link>{' '}
          , avant de retourner son arme contre lui. La police, qui a d’abord
          pensé à un attentat terroriste, a déployé un dispositif de sécurité
          avant de constater qu’il s’agissait d’un drame conjugal. La femme
          (alors âgée de 35 ans) laisse derrière elle deux filles. Le meurtrier
          (38 ans) était le père de la seconde.
        </p>

        <p>
          Irene R. venait de quitter Alberto V.* Peu avant le meurtre, elle
          s’était rendue à la police zurichoise pour se plaindre du comportement
          violent de son compagnon. Les agents n’avaient pas pu contacter le
          mari, introuvable, et n’avaient donc pas pu l’auditionner
          immédiatement. Ils avaient décidé de reporter la confrontation de
          plusieurs jours.
        </p>

        <p>
          Le conjoint n’était effectivement pas à Zurich à ce moment-là, mais
          dans un bus qui le ramenait en Suisse. L’Italien d’origine était
          rentré chez lui quelques jours, dans les Pouilles, et rapportait dans
          ses bagages un pistolet acheté sur place. L’homme, amateur de chasse,
          bénéficiait d’un permis de port d’armes en Italie. Le «Blick» raconte
          que, durant le trajet, le meurtrier a envoyé des messages inquiétants
          à son entourage. «Si quelque chose devait m’arriver, prenez soin de
          mes parents», écrivait-il. Les destinataires n’en ont compris le
          contenu morbide que plus tard.
        </p>

        <Image
          file={require('../../images/irene/tatort-zuerich-1.jpg')}
          className='imageCase'
          source='Il l’a tuée au centre-ville de Zurich. (Foto: Reto Oeschger)'
        />

        <p>
          Le jour du drame, il avait donné rendez-vous à Irene R. dans un café
          de l’Europaallee, à côté de la gare centrale; elle travaillait à deux
          pas de là, dans une filiale d’UBS. Personne ne sait ce qu’ils s’y sont
          dit. Juste après, une fois ressortis, le meurtrier a sorti son arme de
          poing et a fait feu.
        </p>

        <p>
          Irene R. et Alberto V.* se connaissaient depuis l’enfance, selon la
          presse transalpine. Elle était originaire de Ruffano, lui de
          Supersano, deux villages des Pouilles distants de quelques kilomètres.
          La jeune femme est née en Suisse mais passait, enfant, ses vacances
          d’été dans sa région d’origine. C’est là qu’elle a rencontré celui qui
          a d’abord été un amour de jeunesse.
        </p>

        <Image
          file={require('../../images/irene/tatort-zuerich-2.jpg')}
          className='imageCase'
          source='Les policiers ont pensé à un attentat terroriste, avant de constater qu’il s’agissait d’un drame conjugal. (Photo: Reto Oeschger)'
        />

        <p>
          Adolescents, ils se perdent de vue. La jeune femme fait sa vie à
          Zurich. Elle s’y marie, fonde une famille. Irene R. retrouve plus tard
          Alberto V.*, qui abandonne tout à Supersano pour venir s’installer
          avec elle à Schlieren, dans la banlieue zurichoise. Le peintre de
          métier trouve facilement du travail en Suisse alémanique. Le vie du
          couple se poursuit tranquillement. Ils ont un enfant.
        </p>

        <Image
          file={require('../../images/irene/irene-alberto.jpg')}
          className='imageFloatLeft'
          source='Irene R. et Alberto V. ont eu une fille. (Photo: Facebook)'
        />

        <p>
          C’est un accident professionnel dont est victime Alberto V.* qui
          bouleverse tout. Blessé au genou, diminué physiquement, il veut
          retourner au pays, près des siens. Irene R. refuse. Sa vie est en
          Suisse. La tension monte. Les premières disputes naissent, selon des
          voisins. Le projet meurtrier aurait alors mûri dans la tête d’Alberto
          V.*, qui semble avoir planifié l’exécution de sa femme. «Il s’agit
          d'un homicide, suivi d’un suicide», déclare Erich Wenzinger. Le chargé
          de communication du Ministère public du canton de Zurich précise que
          l’enquête a été bouclée. L’identité de l’auteur est connue;
          l’intervention d’un tiers est exclue. Le porte-parole n’en dit pas
          davantage, notamment au sujet du mobile, pour des raisons de
          protection de la personnalité.
        </p>

        <p className='source'>* Prénom d’emprunt</p>
      </>
    )
  },
  {
    n: 'En lire davantage',
    imageOverview: (
      <>
        <img
          src={require('../../images/rahel/rahel-verpixelt-bw.jpg')}
          className='ui fluid image portraitImageFront'
          style={{ margin: '0 auto' }}
        />
      </>
    ),
    imageIntro: (
      <>
        <Image
          file={require('../../images/rahel/rahel-verpixelt.jpg')}
          className='portraitImageBack'
          source='Rahel W. (Photo: Screenshot / Flickr)'
        />
      </>
    ),

    table: (
      <>
        <table className='ui small compact unstackable inverted table fact'>
          <tbody>
            <tr>
              <td className='bold'>Tuée à coups de marteau</td>
            </tr>
            <tr className='top aligned'>
              <td>
                Rahel W. (†39)
                <br />
                <span className='darkgrey'>
                  Assommée le 2 mars 2018 à Brigue (VS)
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </>
    ),

    titleLead: (
      <>
        <h4>Ruiné, il l’assassine</h4>
        <div className='lead'>
          Un notable de Brigue a saisi un marteau d’un kilo pour frapper sa
          femme, Rahel, quinze fois sur le crâne. Il était ruiné, elle ne le
          savait pas.
        </div>
      </>
    ),

    case: (
      <>
        <p>
          Le 2 mars 2018, Paul S.* et Rahel W. étaient dans la maison familiale,
          à Brigue. Selon l’acte d’accusation, Paul S.* a invité sa compagne,
          Rahel W., à s'asseoir sur le divan du salon. Il lui a servi un thé,
          puis a disparu derrière elle pour s’armer d’un marteau et la frapper à
          quinze reprises sur le crâne. Puis il a recouvert la tête avec un
          foulard et a appelé la police, sans se douter qu’une de leurs deux
          fillettes avait assisté à la scène. Le 22 juin 2020, l’homme a été
          condamné à 18 ans de prison. Il a fait recours contre cette décision.
        </p>
        <p>
          Ce drame a bouleversé le Haut-Valais. Paul S.* est connu à Brigue.
          Personne n’aurait imaginé que ce notable local puisse se muer en
          meurtrier. Au lendemain du crime, la population a découvert avec
          surprise que cet enfant du pays cachait la faillite de ses affaires.
          La ruine, selon la cour, est d’ailleurs la raison de son passage à
          l’acte. Le jour des faits, il avait rendez-vous avec les huissiers et
          ne pouvait ainsi plus cacher la situation financière à son épouse, qui
          ne se doutait de rien.
        </p>
        <p>
          Lors du procès, le Ministère public a raconté la lente descente aux
          enfers. C’est au cours de l’été 2011 que le couple se rencontre. Paul
          S.* travaille pour la Confédération, à Berne. Il est marié et quitte
          son épouse peu après. En 2012, il hérite d’une maison familiale, une
          villa cossue sur les hauts de Brigue, et s’y installe avec sa nouvelle
          compagne. Deux filles naissent, en 2012 et 2014. Rahel W. arrête de
          travailler.
        </p>

        <Image
          file={require('../../images/rahel/portrait.jpg')}
          className='imageFloatLeft'
          source='Paul S.* (Photo: Culture Valais)'
        />

        <p>
          Son déménagement coûte cher à Paul S.*, et il n’a plus de revenu. La
          société de conseil qu’il vient de créer à Brigue ne décolle pas. Elle
          est mise en liquidation. L’homme s’enfonce dans les dettes. Il refuse,
          par principe, de recourir aux services sociaux. Il se permet toutefois
          d’aborder des passants dans la rue pour leur demander 50, 100, 500
          francs. Mais à long terme la situation est intenable. Début 2018, sa
          banque lui réclame des assurances pour son hypothèque de 1,2 million
          de francs.
        </p>

        <p>
          Au Tribunal, le condamné a tenté de faire valoir des circonstances
          atténuantes et son avocat a parlé d’un meurtre passionnel, expliquant
          que son client a été pris dans la spirale de l’endettement. Paul S.* a
          reconnu l’acte, mais a assuré avoir agi sans préméditation et a dit
          regretter d’avoir privé ses filles de leur mère. Ces remords n’ont pas
          convaincu la cour.
        </p>

        <p>
          L’enquête a révélé que l’homme avait déjà été violent avec sa femme.
          En 2017, après une dispute, il l’avait étranglée avec une ceinture en
          cuir jusqu’à ce qu’elle perde connaissance. Elle avait été
          hospitalisée pendant trois jours aux soins intensifs de Brigue. Au
          médecin qui s’interrogeait sur l’état alarmant de la patiente, le
          couple avait prétendu qu’un jeu sexuel avait mal tourné. À l’issue du
          procès, le Ministère public a ouvert une enquête pour savoir pourquoi
          l’hôpital n’a pas dénoncé le cas à la police. L’instruction sur cette
          deuxième affaire est en cours.
        </p>

        <p className='maj'>
          <span className='maj-title'>Mise à jour du 11 mars 2021</span>
          <p>
            Paul S. a été condamné en appel à 18 ans de prison. Le tribunal
            cantonal valaisan confirme ainsi le jugement de première instance.
            La Cour l’a reconnu coupable de tentative d’assassinat et
            d’assassinat. L’homme avait étranglé sa compagne jusqu’à
            l’évanouissement le 15 juillet 2017, puis l’avait frappée avec une
            massette le 2 mars 2018 à Brigue, a rappelé le tribunal dans{' '}
            <Link href='https://www.vs.ch/documents/515840/935576/Assassinat+avec+massette+Brigue+2018.pdf/d69418dd-84b6-9342-1a31-311f71d8eb8e?t=1615535494471'>
              un communiqué
            </Link>
            .
          </p>
          <p>
            Le tribunal de district de Brigue avait estimé que le prévenu avait
            agi avec préméditation, ce que l’accusé a une nouvelle fois démenti
            lors de son procès en appel, le 18 février dernier. Son avocat avait
            plaidé six ans de prison.
          </p>
          <p>
            «Il est encore trop tôt pour vous dire si mon client fera recours
            auprès du tribunal fédéral», a indiqué à Keystone-ATS Me Ivo Walter.
            La défense se déterminera lorsqu’elle aura examiné et analysé les
            considérants du jugement.
          </p>
        </p>

        <p className='source'>* Prénom d’emprunt</p>
      </>
    )
  },
  {
    n: 'En lire davantage',
    imageOverview: (
      <>
        <img
          src={require('../../images/anabela/anabela-verpixelt-bw.jpg')}
          className='ui fluid image portraitImageFront'
          style={{ margin: '0 auto' }}
        />
      </>
    ),
    imageIntro: (
      <>
        <Image
          file={require('../../images/anabela/anabela-verpixelt.jpg')}
          className='portraitImageBack'
          source='Anabela C. (Photo: Facebook)'
        />
      </>
    ),

    table: (
      <>
        <table className='ui small compact unstackable inverted table fact'>
          <tbody>
            <tr>
              <td className='bold'>Il tue sa femme et son fils</td>
            </tr>
            <tr className='top aligned'>
              <td>
                Anabela C. (†45)
                <br />
                <span className='darkgrey'>
                  Tuée par balle le 25 avril 2018 à Payerne (VD)
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </>
    ),

    titleLead: (
      <>
        <h4>Il tue sa femme et son fils</h4>
        <div className='lead'>
          Un quadragénaire est accusé d’avoir tiré 30 coups de feu sur sa femme,
          qui venait de le quitter, et sur son fils aîné, dans la cage
          d’escalier d’un immeuble. Leur second enfant était alors hors du
          domicile.{' '}
        </div>
      </>
    ),

    case: (
      <>
        <p>
          Victor* et Anabela C. étaient toujours mariés mais s’étaient séparés
          depuis peu. Elle avait déménagé dans un appartement au centre de
          Payerne (VD). C’est dans la cage d’escalier de l’immeuble que le père
          de famille (alors âgé de 49 ans) aurait tiré sur sa femme (45 ans) et
          sur son fils aîné (18 ans), le 25 avril 2018 en fin de journée. Selon
          la police, Il a tiré 30 coups de feu avec une arme de poing, ce qui
          laisse penser qu’il avait au moins de deux chargeurs. Leur second
          fils, qui jouait chez un copain à Sainte-Croix, a échappé au drame.
        </p>

        <Image
          file={require('../../images/Ausriss_MM_Kapo_VD.png')}
          className='imageCase'
          source='Extrait du communiqué de presse diffusé par la police cantonale vaudoise. (Photo: Screenshot/Canton de Vaud)'
        />

        <p>
          Ce jour-là, l’auteur présumé avait rendez-vous avec sa femme. Il s’est
          présenté chez elle armé. Après avoir tiré, il s’est enfui. La police
          cantonale vaudoise a alors déployé un important dispositif pour le
          retrouver, la traque dans la Broye vaudoise a été longue. Le quotidien
          «24 heures» raconte que, durant la nuit qui a suivi, les enquêteurs
          sont parvenus à entrer en contact téléphonique avec lui. Le groupe de
          négociation a raisonné le fuyard, qui s’est rendu aux forces de
          l’ordre.
        </p>

        <p>
          Les époux, originaires du Portugal, étaient mariés depuis près de
          vingt ans, selon la presse portugaise. Des témoignages indiquent que
          Victor C.* n’aurait pas supporté la séparation. Après qu’elle l’avait
          quitté, il s’était rendu plusieurs fois chez elle. Les voisins disent
          avoir entendu des bruits de dispute et il aurait proféré des menaces
          physiques contre son épouse. Selon des amies, celle-ci était
          convaincue que son mari était incapable de passer à l’acte.
        </p>

        <Image
          file={require('../../images/anabela/verdaechtiger.jpg')}
          className='imageFloatLeft'
          source='Victor C.* dans un stand de tir (photo: Gazeta Lusofona)'
        />

        <p>
          Victor C.* avait une maison au Portugal, dans laquelle la police
          locale a découvert un petit arsenal composé d’armes à feu de
          différents calibres, de 1282 munitions, de seize baïonnettes et d’un
          sabre. L’homme aimait les stands de tir et le faisait savoir sur les
          réseaux sociaux. La police vaudoise a précisé que l’arme du crime lui
          appartenait et qu’il en possédait le permis.
        </p>

        <p>
          Les proches de la famille ne comprennent toujours pas pourquoi ce
          maçon sans histoire et sans casier judiciaire a pu commettre un acte
          aussi violent. Pour quelle raison, Victor C.* aurait-il vidé son arme
          sur sa femme et son fils? Avait-il prémédité son geste? C’est ce que
          l’enquête doit encore éclaircir. La procureure chargée du dossier n’a
          voulu faire aucun commentaire. Le suspect reste présumé innocent
          jusqu’à l’issue du procès qui devrait avoir lieu au printemps
          prochain.
        </p>

        <p className='source'>* Prénom d’emprunt</p>
      </>
    )
  },
  {
    n: 'En lire davantage',
    imageOverview: (
      <>
        <img
          src={require('../../images/laetitia/laetitia-verpixelt-bw.jpg')}
          className='ui fluid image portraitImageFront'
          style={{ margin: '0 auto' }}
        />
      </>
    ),
    imageIntro: (
      <>
        <Image
          file={require('../../images/laetitia/laetitia-verpixelt.jpg')}
          className='portraitImageBack'
          source='Laetitia D. (Photo: Le Nouvelliste)'
        />
      </>
    ),

    table: (
      <>
        <table className='ui small compact unstackable inverted table fact'>
          <tbody>
            <tr>
              <td className='bold'>Meurtre passionnel?</td>
            </tr>
            <tr className='top aligned'>
              <td>
                Laetitia D. (†33)
                <br />
                <span className='darkgrey'>
                  Étranglée le 14 mai 2018 à Sion (VS)
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </>
    ),

    titleLead: (
      <>
        <h4>Il l’a tuée, mais il ne voulait pas le faire</h4>
        <div className='lead'>
          L’auteur présumé reconnaît les faits, mais prétend que son crime
          n’était pas prémédité. Selon lui, c’est une dispute qui a mal tourné.
          Il a agi sous le coup de l’émotion. La famille de la victime conteste.{' '}
        </div>
      </>
    ),

    case: (
      <>
        <p>
          Alfons T.* reconnaît l’avoir tuée, mais il ne voulait pas le faire.
          Selon son avocate, Béatrice Pilloud, son client a expliqué aux
          policiers que dans la nuit du 14 au 15 mai 2018, aux alentours de
          minuit, il a voulu quitter une nouvelle fois Laetitia D. Mais elle a
          tenté de l’en empêcher. Elle a menacé de se suicider; elle s’est mise
          une corde autour du cou et s’est pendue à la balustrade des escaliers.
          Une dispute a éclaté. Elle l’a saisi par les habits; il lui a attrapé
          le cou. Il a serré fort et a glissé. Ce n’est qu’au moment où il a
          remarqué le changement de couleur des lèvres de la victime qu’il dit
          avoir pris conscience de son acte et relâché l’étreinte.
        </p>
        <p>
          Le crime a eu lieu dans l’appartement du couple aux Agettes, au-dessus
          de Sion (VS). Après avoir compris que Laetitia D. était morte, Alfons
          T.* reconnaît ne pas avoir tenté de la sauver, toujours selon son
          avocate. Il n’a pas non plus appelé les secours. Il a quitté les lieux
          dans la nuit noire pour rejoindre à pied la ville de Sierre où
          habitait sa sœur. À 7 heures, ils se sont présentés au poste de police
          pour annoncer l’homicide.
        </p>

        <p>
          Les agents ont retrouvé le corps de Laetitia D. chez elle. Elle était
          pendue au bout d’une corde, mais les pieds touchaient le sol. Suicide
          ou meurtre? L’autopsie n’a pas pu déterminer si la mort par
          strangulation est due à la corde ou aux mains de l’auteur.
        </p>

        <h5>Le blanc des yeux coloré en noir</h5>
        <p>
          Au moment des faits, les deux partenaires sont âgés de 33 ans. Alfons
          T.* est Portugais et séjourne illégalement en Suisse, sans boulot
          fixe. Ce tatoueur de métier impressionne: il s’est coloré le blanc des
          yeux en noir. Laetitia D. est Française et travaille en Suisse. Ils se
          sont rencontrés en Valais deux ans plus tôt, habitent ensemble mais se
          disputent régulièrement au sujet d’une ancienne relation sentimentale
          d’Alfons T.* Il en était d’ailleurs question le soir du meurtre.
        </p>

        <p>
          Le procès est attendu ces prochains mois. Béatrice Pilloud dit qu’elle
          plaidera le meurtre passionnel, au sens de l’article 113 du Code
          pénal. Selon elle, son client a agi sous le coup de l’émotion et doit
          bénéficier de circonstances atténuantes. L’article 113 prévoit une
          peine de prison maximale de 10 ans.
        </p>

        <p>
          Guérin de Werra, avocat de la mère de Laetitia D., conteste cette
          version des faits. «Je vais démontrer que ce monsieur ne pouvait pas
          ignorer ce qu’il faisait. Il est indécent de soutenir aujourd’hui
          qu’il n’a pas voulu la tuer.» Il ajoute que ce drame ne peut
          bénéficier d’aucune circonstance atténuante et qu’elle a terrassé la
          famille de la victime, qui réside en France. «Sa mère est effondrée.
          Elle était encore très proche d’elle.»
        </p>

        <p className='source'>* Prénom d’emprunt</p>
      </>
    )
  },
  {
    n: 'En lire davantage',
    imageOverview: (
      <>
        <img
          src={require('../../images/treesamai/treesamai-verpixelt-bw.jpg')}
          className='ui fluid image portraitImageFront'
          style={{ margin: '0 auto' }}
        />
      </>
    ),
    imageIntro: (
      <>
        <Image
          file={require('../../images/treesamai/treesamai-verpixelt.jpg')}
          className='portraitImageBack'
          source='La victime était âgée de 44 ans. Photo: zvg'
        />
      </>
    ),

    table: (
      <>
        <table className='ui small compact unstackable inverted table fact'>
          <tbody>
            <tr>
              <td className='bold'>Le diable est dans la cave</td>
            </tr>
            <tr className='top aligned'>
              <td>
                Treesamai B. (†44)
                <br />
                <span className='darkgrey'>
                  Poignardée le 16 mai 2018 à Thal (SG)
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </>
    ),

    titleLead: (
      <>
        <h4>Il croit que le diable veut le tuer et le manger</h4>
        <div className='lead'>
          Un homme a poignardé sa compagne dans la cave de son immeuble. Il
          présente des troubles psychiatriques.{' '}
        </div>
      </>
    ),

    case: (
      <>
        <p>
          Georg T.* avait des hallucinations. Il était persuadé que lui et sa
          compagne, Treesamai B., étaient menacés par le diable, qui voulait les
          tuer et les manger. La police cantonale a retrouvé le couple allongé
          sur le sol de la cave de l’immeuble de leur domicile à Thal (SG). Les
          deux étaient grièvement blessés. L’auteur (alors âgé de 50 ans) a
          survécu, pas sa victime (44 ans), qui avaient reçu six coups de
          couteau en pleine poitrine et dont les avant-bras étaient tailladés.
          Les agents ont séquestré 29 couteaux.
        </p>

        <p>
          C’est un des voisins qui a donné l’alerte, selon l’acte d’accusation,
          peu après 7 heures le 16 mai 2018. Durant la nuit, il avait remarqué
          le remue-ménage du couple, qui s’était déplacé au sous-sol, dans
          l’abri anti-atomique. À 4 h 50, le témoin avait été réveillé par des
          cris et des claquements de porte. Il s’était alors rendu à la cave
          pour s’assurer qu’il n’y avait aucun problème. «Pars, tu es Satan»,
          lui a répondu Georg T.* depuis le fond de son abri, dans lequel il
          s’était enfermé avec Treesamai. Le voisin a attendu deux heures avant
          d’appeler la police.
        </p>

        <Image
          file={require('../../images/treesamai/tatort-thal-1.jpg')}
          className='imageCase'
          source='La police a trouvé deux corps dans la cave. (Photo: «20 Minutes)'
        />

        <p>
          «Lorsque la police s’est présentée chez moi, j’ai tout de suite su
          qu’il s’agissait de ma mère», nous a raconté sa fille, qui connaissait
          les problèmes psychiques du compagnon de Treesamai. L’homme avait été
          interné à la clinique de Wil pendant deux mois, fin 2017. Il en était
          ressorti, mais, selon la fille de la défunte, il n’était pas guéri et
          présentait toujours une forte dépendance à l’alcool. «Je me demande
          aujourd’hui encore pourquoi il a pu sortir de la clinique.»
        </p>

        <p>
          La victime, d’origine thaïlandaise, vivait depuis longtemps en Suisse.
          L’auteur, lui, boucher de formation, est d’origine allemande. Ils se
          sont rencontrés dans un bar. Peu de temps après, elle s'est installée
          chez son amant à Thal, à la frontière avec l’Autriche. Le couple,
          isolé, vivait de petits boulots, selon la presse alémanique.
        </p>

        <Image
          file={require('../../images/treesamai/portrait-goerg.jpg')}
          className='imageFloatLeft'
          source='Georg T.* avait des problèmes psychiatriques (Photo: Facebook)'
        />

        <p>
          Treesamai était divorcée et avait eu deux enfants avant de rencontrer
          Georg T. «C'était une mère aimante», explique sa fille. La mère
          partageait en famille son goût de la nature, du dessin et de la
          cuisine. C’était une femme sociable qui s’entendait bien avec tout le
          monde. Sa dernière rencontre lui a été fatale. Ce n’était pas la bonne
          personne, elle s’est trompée, selon sa fille, qui demande réparation.
        </p>

        <p>
          Le Ministère public reconnaît la maladie psychiatrique de Georg T.*
          L’acte d’accusation évoque sa maladie. Le jour du meurtre, le malade
          délirait. Il croyait qu'il se battait avec le diable et pensait le
          poignarder, écrit le procureur chargé du dossier. Il n’aurait pas eu
          conscience qu’en réalité il blessait mortellement sa compagne et
          s’était infligé de graves blessures.
        </p>

        <p>
          Le procès doit avoir lieu prochainement. Le Ministère public
          saint-gallois requiert le petit internement, qui ordonne des soins
          thérapeutiques, au sens de l’article 59 du Code pénal. L’expertise
          psychiatrique effectuée en cours d’enquête indique que l’auteur
          présumé n’est pas considéré comme coupable au sens pénal, mais qu’il
          doit recevoir des soins dans un établissement adapté.
        </p>

        <p>Contacté, l’avocat de Georg T. n’a voulu faire aucun commentaire.</p>

        <p className='maj'>
          <span className='maj-title'>Il a été condamné</span>
          <p>
            Début décembre 2020, la cour du{' '}
            <Link href='https://www.tagblatt.ch/ostschweiz/stgallen/kreisgericht-rorschach-der-teufel-war-hinter-mir-her-und-wollte-mich-toeten-52-jaehriger-ersticht-freundin-und-verletzt-sich-selber-gericht-schickt-ihn-in-die-kleine-verwahrung-ld.2073739'>
              Tribunal de Rorschach
            </Link>{' '}
            a reconnu coupable Georg T. du meurtre de sa compagne. "Le diable
            était après moi et voulait me tuer" au moment des faits, a répété
            durant l’audience le meurtrier qui est âgé de 52 ans. L’homme qui
            souffre de troubles mentaux et de dépendance à l’alcool a été
            condamné à suivre une mesure institutionnelle dans un établissement
            psychiatrique fermé, selon l’article 59 du Code pénal. Ce n’est
            qu’une fois guéri qu’il pourra envisager une éventuelle libération.
          </p>
        </p>

        <p className='source'>* Prénom d’emprunt</p>
      </>
    )
  },
  {
    n: 'En lire davantage',
    imageOverview: (
      <>
        <img
          src={require('../../images/mijaser/avatar-mijaser.svg')}
          className='ui fluid image portraitImageFront'
          style={{ margin: '0 auto' }}
        />
      </>
    ),
    imageIntro: (
      <>
        {/* <Image
          file={require('../../images/mijaser/avatar-carole.jpg')}
          className='portraitImageBack'
          source='Mijaser F. (†44)'
        /> */}
      </>
    ),

    table: (
      <>
        <table className='ui small compact unstackable inverted table fact'>
          <tbody>
            <tr>
              <td className='bold'>51 coups de couteau</td>
            </tr>
            <tr className='top aligned'>
              <td>
                Mijaser F. (†44)
                <br />
                <span className='darkgrey'>
                  Poignardée le 18 mai 2018 à Wil (SG)
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </>
    ),

    titleLead: (
      <>
        <h4>Un meurtre sans raison</h4>
        <div className='lead'>
          Il a frappé sa femme, Mijaser F., de 51 coups avec un couteau de 10,5
          centimètres, puis a rangé la lame dans un tiroir. La victime n’est pas
          morte sur le coup.
        </div>
      </>
    ),

    case: (
      <>
        <p>
          Le crime est intentionnel et odieux, selon l’acte d’accusation que
          nous avons consulté. Murat F.* a poignardé 51 fois sa femme, Mijaser
          F., le 18 mai 2018. Surprise par-derrière dans sa chambre à coucher,
          la femme n’a pas eu le temps de se défendre. La victime (alors âgée de
          44 ans) a été abandonnée sur le sol de l’appartement à Wil (SG), se
          vidant de son sang. Au lieu de lui prêter secours, le meurtrier (48
          ans) s’est rendu au poste de police pour avouer son crime.
        </p>
        <Image
          file={require('../../images/mijaser/tatort-wil.jpg')}
          className='imageCase'
          source=' Le drame a eu lieu à Wil. (Photo: Andrea Zahler)'
        />
        <p>
          L’acte d’accusation raconte que, peu avant les faits, les époux
          d’origine macédonienne se sont chamaillés au sujet des courses à
          faire. Le mari a attendu que les deux enfants quittent le domicile
          pour agir. Une fois seul avec sa femme, il s’est rendu dans la cuisine
          pour prendre un couteau. L’auteur a caché la lame de 10,5 centimètres
          dans la poche de son pantalon avant de ressortir de la pièce.
        </p>
        <p>
          Murat F.*, armé, a rejoint sa femme dans la chambre à coucher. Il a
          saisi le couteau avec sa main droite et a frappé 51 fois. L’acte
          d’accusation liste les multiples blessures, souvent profondes, sur la
          joue, la poitrine, les poumons, le cou, le visage, l’estomac.
        </p>
        <p>
          Après cela, l’homme a nettoyé l’arme du crime et l’a remise dans le
          tiroir de la cuisine. Il s’est changé et, avant de quitter le
          domicile, a fermé la porte de la chambre à coucher, abandonnant sa
          femme grièvement blessée qui baignait dans son sang sur le sol. Ce
          faisant, il savait qu’il ne lui laissait aucune chance, selon l’acte
          d’accusation.
        </p>
        <p>
          Le procès a eu lieu en décembre 2019. Les débats ont rappelé que le
          père criminel s’est rendu au poste de police après le meurtre. Il y
          est entré, mais ne s’est pas dénoncé tout de suite. Il a fait la queue
          pendant trente minutes dans la salle d’attente comme si de rien
          n’était. Lorsque son tour est venu, il s’est levé et a déclaré en
          dialecte alémanique: «J’ai eu une mauvaise expérience. Je me suis
          disputé avec ma femme et je l'ai coupée avec un couteau.»
        </p>
        <p>
          L’homme a été condamné à 12 ans et demi de prison, suivis d’une
          expulsion du territoire pendant quinze ans. Il est également soumis à
          une obligation de soins thérapeuthiques, au sens de l’article 59 du
          Code pénal. Murat F.* souffre de schizophrénie paranoïaque et était
          sous traitement psychiatrique depuis des années. Une expertise,
          réalisée durant l’enquête, a confirmé sa maladie, tout en précisant
          qu’il pouvait toutefois reconnaître les conséquences pénales de son
          geste. Le mobile, lui, n’a jamais été clairement établi.
        </p>
        <p className='source'>* Prénom d’emprunt</p>
      </>
    )
  },
  {
    n: 'En lire davantage',
    imageOverview: (
      <>
        <img
          src={require('../../images/carole/avatar-carole.svg')}
          className='ui fluid image portraitImageFront'
          style={{ margin: '0 auto' }}
        />
      </>
    ),
    imageIntro: (
      <>
        {/* <Image
          file={require('../../images/carole/avatar-carole.jpg')}
          className='portraitImageBack'
          source='Carole M. (†31)'
        /> */}
      </>
    ),

    table: (
      <>
        <table className='ui small compact unstackable inverted table fact'>
          <tbody>
            <tr>
              <td className='bold'>Un drame prévisible</td>
            </tr>
            <tr className='top aligned'>
              <td>
                Carole M. (†31)
                <br />
                <span className='darkgrey'>
                  Étranglée le 16 novembre 2018 à Yverdon-les-Bains (VD)
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </>
    ),

    titleLead: (
      <>
        <h4>Il la maltraitait, elle niait l’évidence</h4>
        <div className='lead'>
          Carole était sous le joug d’un récidiviste qui la battait. Son
          entourage a tenté de la protéger. Les autorités ont été prévenues. En
          vain.{' '}
        </div>
      </>
    ),

    case: (
      <>
        <p>
          Lors de la reconstitution, Ralf F.*, qui a reconnu les faits, a tenté
          de montrer comment il a tué sa compagne Carole. L’homme (alors âgé de
          28 ans), grand et fort, et la jeune fille (31 ans), petite et fine, se
          seraient disputés. Toujours selon l’avocate de la victime, Anne-Louise
          Gilliéron, l’auteur présumé a raconté que le couple est tombé au sol
          et qu’il y a eu une forte pression sur la cage thoracique de la
          victime. Cette explication n’a pas convaincu l’avocate: «Rien n’est
          clair. Nous ne savons toujours pas comment elle est morte.»
        </p>

        <p>
          Ralf F.* a tué sa compagne chez elle à Yverdon-les-Bains (VD),
          vendredi matin 16 novembre vers 8 heures. Il est ensuite parti à
          Lausanne avec le troisième enfant en bas âge de la victime pour y
          passer la journée, l’abandonnant dans l’appartement. Selon Anne-Louise
          Gilliéron, les enquêteurs ne savent pas à quelle heure précise la
          jeune femme est décédée, ni si elle a agonisé. Une expertise, qui
          était toujours en cours en août 2020, pourrait répondre à ces
          questions.
        </p>

        <p>
          Le meurtrier présumé s’est rendu à la police un jour après le crime.
          Il n’a pas dit ce qu’il a fait à Lausanne ni expliqué pourquoi la
          dispute a éclaté. «Il a donné plusieurs versions des faits», explique
          Anne-Louise Gilliéron. Contactée, l’avocate du meurtrier présumé n’a
          pas voulu faire de commentaire. Tout comme le procureur chargé de
          l’enquête. Le procès n’a pas eu lieu. L’instruction peut encore durer
          plusieurs mois. Par principe, l’auteur bénéficie toujours de la
          présomption d’innocence.
        </p>

        <Image
          file={require('../../images/carole/tatort-yverdon-2.jpg')}
          className='imageCase'
          source='La victime logeait dans ce quartier à Yverdon-les-Bains (Photo: Jean-Paul Guinnard / 24 Heures)'
        />

        <h5>«Un cas exemplaire de violence conjugale»</h5>
        <p>
          «Nous sommes face à un cas exemplaire de violence conjugale», reprend
          Anne-Louise Gilliéron. L’homicide est la dernière étape d’une relation
          violente qui a duré deux ans. Le couple se rencontre dans un bar en
          2017. Les deux sont issus d’un milieu défavorisé. Aucun des deux ne
          travaille. Carole est à l’aide sociale. Mère au foyer, elle élève son
          troisième enfant, un nourrisson. Ses deux premiers, des jumeaux, sont
          déjà grands.
        </p>

        <p>
          Le meurtrier avait des antécédents de violence, selon «24 heures». Il
          frappait sa compagne. Elle avait tenté de chercher de l’aide, mais
          Ralf F.* la menaçait, faisait le vide autour d’elle, la manipulait.
          Mise sous pression, Carole, qui disait l’aimer, avait appris à vivre
          avec cette agressivité. Lorsque les marques des coups étaient trop
          voyantes, elle restait chez elle. «Elle n’a pas su se mettre à l’abri.
          Elle était sous son emprise», raconte son avocate.
        </p>

        <p>
          Le meurtre a bouleversé la région du Nord vaudois. Le couple était
          connu. La police était intervenue plusieurs fois, le Service de
          protection de la jeunesse aussi. L’entourage de la victime avait tenté
          de la raisonner. En vain. Tout le monde voyait qu’il y avait un
          problème, mais personne n’a pu empêcher le drame. Après la mort de
          Carole, la population locale, sous le choc, est descendue dans la rue
          pour exprimer sa solidarité. Une collecte de fonds a été organisée.
          «Nous nous sommes sentis tous un peu coupables. Moi-même, je me suis
          dit que j’aurais pu en faire davantage pour la protéger», conclut
          Anne-Louise Gilliéron.
        </p>

        <p>
          Après 4 ans et demi d’instruction, le procès a eu lieu au printemps
          2023. Le 25 mai, le Tribunal d’Yverdon a condamné l’auteur “sans
          scrupule”, Nicolas S. (né en 1990), a une très lourde peine: 14 ans de
          prison, puis l’internement ordinaire. Cette mesure complémentaire
          permettra de maintenir en détention le potentiel récidiviste, tant que
          la situation sécuritaire le justifie.
        </p>

        <p>
          La cour a estimé que ce crime n’étais pas un simple meurtre, mais un
          assassinat “odieux”. Le coupable qui a reconnu les faits n’a laissé
          «aucune chance à sa victime (ndlr: âgée de 31 ans) de s’en sortir»,
          elle n’a pas pu se défendre. L’homme (né en 1990) lui a serré le cou
          pendant de longues minutes sans s’arrêter, avec détermination
        </p>

        <Image
          file={require('../../images/carole/tatort-yverdon-1.jpg')}
          className='imageCase'
          source='Des bougies à Yverdon, en hommage à la victime. (Photo: Jean-Paul Guinnard / 24 Heures)'
        />
        <p className='source'>* Prénom d’emprunt</p>
      </>
    )
  },
  {
    n: 'En lire davantage',
    imageOverview: (
      <>
        <img
          src={require('../../images/zwei-unbekannte/avatar-zwei-unbekannte.svg')}
          className='ui fluid image portraitImageFront'
          style={{ margin: '0 auto' }}
        />
      </>
    ),
    imageIntro: (
      <>
        {/* <Image
          file={require('../../images/zwei-unbekannte/avatar-zwei-unbekannte.svg')}
          className='portraitImageBack'
          source='Carole M. (†31)'
        /> */}
      </>
    ),

    table: (
      <>
        <table className='ui small compact unstackable inverted table fact'>
          <tbody>
            <tr>
              <td className='bold'>Deux anonymes</td>
            </tr>
            <tr className='top aligned'>
              <td>
                Deux femmes majeures
                <br />
                <span className='darkgrey'>
                  Tuées par leur conjoint ou ex-conjoints en 2018
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </>
    ),

    titleLead: (
      <>
        <h4>Les autorités ne communiquent pas</h4>
        <div className='lead'>
          Deux féminicides conjugaux en 2018 restent anonymes. Impossible de
          connaître la date et le lieu de la mort ni le nom des victimes, pour
          une question de protection de la personnalité.
        </div>
      </>
    ),

    case: (
      <>
        <p>
          L’Office fédéral de la statistique recense officiellement seize
          féminicides conjugaux entre partenaires ou ex-partenaires en 2018.
          Plusieurs sources d’informations disponibles nous ont permis de les
          identifier, puis de les reconstituer. D’abord les médias, qui relatent
          les faits à chaud, au lendemain des drames. Puis, au cours des
          enquêtes, les magistrats, les parties et leurs avocats révèlent
          d’autres détails s’ils l’estiment nécessaire. Enfin, le moment du
          procès est déterminant, puisque l’acte d’accusation, les débats et le
          verdict fixent les faits en public.
        </p>

        <p>
          Mais deux de ces féminicides entre partenaires ou ex-partenaires
          restent anonymes. Les autorités ont en effet la possibilité de ne pas
          communiquer sur certains meurtres pour une question de protection de
          la personnalité ou du respect des proches. La pratique peut changer
          entre les cantons, certains étant plus transparents que d’autres.
        </p>

        <p>
          Un de ces deux cas demeure totalement obscur. Impossible de savoir où
          ni quand le féminicide a eu lieu. Nous avons pu déterminer, en
          revanche, que le deuxième s’est déroulé dans le canton de Zurich.
          Contactées, les autorités le reconnaissent. Elles expliquent qu’aucune
          communication officielle n’a été faite à l’époque. Le grand public et
          les médias n’en ont ainsi jamais entendu parler.
        </p>

        <p>
          Pourquoi cette discrétion? «Pour une question de protection de la
          personnalité», explique Stefan Oberlin, porte-parole de la police
          cantonale zurichoise. Aucune information n’est donc donnée sur le nom,
          l’âge, la nationalité et le contexte de la mort. Le communiquant
          précise toutefois qu’il s’agit bien d’un féminicide, suivi du suicide
          de l’auteur. Selon nos informations, l’auteur était un retraité qui
          aurait tué sa femme malade.
        </p>
      </>
    )
  },
  {
    n: 'En lire davantage',
    imageOverview: (
      <>
        <img
          src={require('../../images/sonia/avatar-sonia.svg')}
          className='ui fluid image portraitImageFront'
          style={{ margin: '0 auto' }}
        />
      </>
    ),
    imageIntro: (
      <>
        {/* <Image
          file={require('../../images/sonia/avatar-sonia.svg')}
          className='portraitImageBack'
          source='Sonia R. (†43)'
        /> */}
      </>
    ),

    table: (
      <>
        <table className='ui small compact unstackable inverted table fact'>
          <tbody>
            <tr>
              <td className='bold'>L’accident pourrait être un meurtre</td>
            </tr>
            <tr className='top aligned'>
              <td>
                Sonia R. (†43)
                <br />
                <span className='darkgrey'>
                  Décédée 16 avril 2014 à Küsnacht (ZH)
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </>
    ),

    titleLead: (
      <>
        <h4>L’auteur présumé est rattrapé par son passé</h4>
        <div className='lead'>
          Il est accusé en 2018 d’avoir tué sa femme alors que la mort de
          celle-ci avait été jugée accidentelle en 2014. L’enquête de
          l’assurance a tout changé.{' '}
        </div>
      </>
    ),

    case: (
      <>
        <p>
          Sonia R. a été retrouvée morte dans sa baignoire, chez elle à Küsnacht
          (ZH), le 16 avril 2014. L’Institut médicolégal de Zurich suggère alors
          qu’elle a succombé à une crise d’épilepsie, puis à une noyade. La
          justice s’oriente vers la thèse de l’accident. Cette mort apparemment
          d’origine naturelle il y a six ans est suspecte aujourd’hui. La
          statistique officielle la considère comme un fémicide conjugal depuis
          2018.
        </p>
        <p>
          Cette affaire est exceptionnelle. Mais elle est révélatrice de la
          réalité statistique. Les chiffres ne sont pas forcément gravés dans le
          marbre. Certaines enquêtes peuvent durer plusieurs années. Des
          rebondissements peuvent se manifester longtemps après le drame et
          transformer l’identité d’un dossier. Un accident peut ainsi devenir un
          crime. À l’inverse, un présumé meurtrier peut se révéler innocent.
        </p>
        <p>
          Comment expliquer ce retournement de situation? C’est l’ex-mari de
          Sonia R. qui a tout déclenché. Après le décès, l’homme fait valoir son
          droit à des indemnités auprès de l’assurance. La compagnie ouvre une
          enquête de routine qui remet pourtant en question la version
          officielle. Le médecin légiste mandaté estime que l’intervention d’un
          tiers est tout à fait possible. Il pourrait s’agir d’un crime.
        </p>
        <p>
          La suite des investigations oriente les soupçons vers l’ex-conjoint.
          Les enquêteurs privés découvrent par hasard le passé troublant du
          couple en Espagne. En décembre 2012, Sonia R. et le suspect sont
          mariés. Ils passent leurs vacances avec leur fils sur l’île de
          Majorque. Un document de la police locale indique qu’il a appelé en
          urgence les secours pour annoncer l’accident de sa femme. Une crise
          d’épilepsie aurait provoqué sa chute du premier étage de la maison de
          vacances. Elle est grièvement blessée.
        </p>

        <Image
          file={require('../../images/sonia/ausriss-urteil-bundesgericht.png')}
          className='imageCase'
          source="Extrait d'un jugement d'un tribunal fédéral sur l'affaire. (Photo: Capture d'écran / bger.ch)"
        />

        <p>
          Ces documents espagnols sont analysés en 2016 par des experts
          zurichois, qui concluent que les blessures de Sonia R. à Majorque ne
          sont pas compatibles avec une chute mais ressemblent davantage aux
          conséquences d’un violent choc avec une voiture. À l’époque, la
          famille voyageait avec un véhicule de location. Par ailleurs, le coup
          à la tête pourrait bien avoir été donné par un coup de poing.
        </p>
        <p>
          Le dossier passe alors dans les mains de la justice. L’auteur présumé
          est aujourd’hui soupçonné dans les deux affaires, de Majorque et de
          Küsnacht. «Le Ministère public de Zurich a conclu sa procédure à la
          fin du mois de novembre 2019 e porté plainte contre l'accusé devant le
          Tribunal de district de Meilen pour tentative de meurtre ainsi que
          pour tentative de fraude», déclare Erich Wenzinger, porte-parole du
          Ministère public du canton de Zurich. Le procès est prévu pour octobre
          2020. Entre-temps, l’accusé reste présumé innocent. Contacté, son
          avocat n’a voulu faire aucun commentaire.
        </p>
        <p className='source'>* Prénom d’emprunt</p>
      </>
    )
  }
]
